const filterNegativeNumber = () => {
  const inputFields = document.querySelectorAll("input.positive-number");
  inputFields.forEach((inputField) => {
    inputField.addEventListener("input", ({ target }) => {
      if (!(target instanceof HTMLInputElement)) return;

      const value = target.value;

      // 数字以外の文字が入力された場合、その文字を取り除いてセットしなおす
      if (isNaN(Number(value))) target.value = value.replace(/\D/g, "");
    });
  });
};

const initialInputFilter = () => {
  ["turbo:load", "turbo:render"].forEach((event) => {
    document.addEventListener(event, () => {
      filterNegativeNumber();
    });
  });
};

export default initialInputFilter;
